export enum IncomeRangeEnum {
  UP_TO_10000 = 'До 10 000 грн',
  FROM_10000_TO_20000 = '10 000 - 20 000 грн',
  FROM_20000_TO_30000 = '20 000 - 30 000 грн',
  FROM_30000_TO_50000 = '30 000 - 50 000 грн',
  MORE_THAN_50000 = '50 000 грн',
}

export enum IncomeRangeStarfinEnum {
  UP_TO_10000 = 'До 10 000 грн',
  FROM_10000_TO_20000 = 'від 10 001 до 20 000 грн',
  FROM_20000_TO_30000 = 'від 20 001 до 30 000 грн',
  FROM_30000_TO_50000 = 'від 30 001 до 50 000 грн',
  MORE_THAN_50000 = 'Більше 50 000 грн',
}
